'use client'

import { Rail } from '@src/components/Rail/Rail'
import { SKUSelectionRailDefaults } from '@src/components/SKUSelectionRail/SKUSelectionRail.defaults'
import type { SKUSelectionRailProps } from '@src/components/SKUSelectionRail/SKUSelectionRail.props'
import { SKUSelectionRailItem } from '@src/components/SKUSelectionRail/SKUSelectionRailItem/SKUSelectionRailItem'
import { useOnMount } from '@src/hooks/useOnMount'
import { useSKUSelectionStore } from '@src/stores/SKUSelectionStore'

export const SKUSelectionRail = (props: SKUSelectionRailProps = SKUSelectionRailDefaults) => {
  const { railProps, items, maxSelection, minSelection, builderBlock } = props
  const slug = railProps.slug

  const setupGroup = useSKUSelectionStore((state) => state.setupGroup)

  useOnMount(() => {
    if (!slug) return

    setupGroup(slug, minSelection ?? 1, maxSelection ?? 1)
  })

  const itemsBlocks = items.map((item, i) => {
    return {
      blocks: [
        <SKUSelectionRailItem
          key={i}
          imageAlt={item.imageAlt}
          blocks={item.blocks}
          columnsDesktop={railProps.columnsDesktop}
          imageStyle={railProps.imageStyle}
          imageUrl={item.imageUrl}
          sku={item.sku}
          railSlug={railProps.slug}
          builderBlock={builderBlock}
        />,
      ],
    }
  })

  return <Rail {...railProps} items={itemsBlocks} />
}
